module.exports = __webpack_public_path__ + "static/img/4020.a8c595b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4020.png
// module id = 727
// module chunks = 0 1 12